import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import Global from '../../../store/global-selectors';

import CurrencyColumn from '../../../components/columns/currency-column';
import messages from '../messages';

const AmountPaidColumn = ({ fulfillmentPlanId }) => {
  const [{ amountSummary }] = useSelector((state) =>
    Global.selectEntitiesSalesOrdersByFulfillmentPlanIds(state, {
      fulfillmentPlanIds: [fulfillmentPlanId],
    }),
  );
  const { totalPaid } = amountSummary ?? {};

  if (!totalPaid) {
    return '';
  }
  const { value, code } = totalPaid;
  return <CurrencyColumn currencyCode={code} value={value} />;
};

AmountPaidColumn.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
};

export default {
  getMessageDescriptor: () => messages.amountPaid,
  id: 'amount-paid',
  render: (data, { isFirstOfType = true } = {}) => {
    if (!data || !isFirstOfType) {
      return '';
    }

    return <AmountPaidColumn fulfillmentPlanId={data.id} />;
  },
};
